import { render, staticRenderFns } from "./TraxTrainingGroupRegistrationCrud.vue?vue&type=template&id=5c9fb18c"
import script from "./TraxTrainingGroupRegistrationCrud.vue?vue&type=script&lang=js"
export * from "./TraxTrainingGroupRegistrationCrud.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports